/**
 * Mobile menu
 */

document.addEventListener('DOMContentLoaded', function () {

  if ('loading' in HTMLImageElement.prototype) {
    const images = document.querySelectorAll<HTMLImageElement>('img[loading="lazy"]');
    images.forEach(img => {
      if(img.dataset.src) {
        img.src = img.dataset.src!;
      }
    });
  } else {
    // Dynamically import the LazySizes library
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.2/lazysizes.min.js';
    document.body.appendChild(script);
  }

  loadMobileMenu()
  document.querySelector('body.woocommerce') ? makeProductsBiggerWhenLessThanFour() : ''
  document.querySelector('.faqItems') ? loadFaqSection() : ''
})

document.querySelector('body.woocommerce-cart') ? mobileCartProductThumbs(): ''
document.querySelector('.artists') || document.querySelector('#events') ? loadArtistsPage() : ''
document.querySelector('#muralModal') ? loadMuralModal() : ''
document.querySelector('#events') ? loadEventsInfos() : ''
document.querySelector('#tickets') ? loadSwiperTickets() : ''
document.querySelector('#photoModal') ? loadSwiperPhoto() : ''
document.querySelector('#youtubeModal') ? loadYoutube() : ''
document.querySelector('#swiperProgram') ? loadSwiperProgram() : ''
document.querySelector('#scrollIcon') ? loadScroll() : ''
if(document.querySelector('.product-slider')) {
  loadProductSlider()
}
if (document.querySelector('[data-fslightbox]')) {
  tryToRefreshFsLightbox();
}

async function loadArtistsPage() {
  const { artistsPage } = await import('./modules/artist.js')
  artistsPage()
}

async function loadMuralModal() {
	const { muralsModal } = await import('./modules/murals-modal.js')
	muralsModal()
}

async function loadEventsInfos() {
  const { eventInfos } = await import('./modules/event-infos.js')
  eventInfos()
}

async function loadMobileMenu() {
  const { mobileMenu } = await import('./modules/mobileMenu.js')
  mobileMenu()
}
async function loadFaqSection() {
  const { faq } = await import('./modules/faq.js')
  faq()
}

async function loadSwiperPhoto() {
  const { swiperPhoto } = await import('./modules/swiper.js')
  await import('../styles/modules/swiperPhotos.scss')
  swiperPhoto()
}

async function loadYoutube() {
  const { youtubeModal } = await import('./modules/youtube-modal.js')
  await import('../styles/modules/youtubeModal.scss')
  youtubeModal()
}
async function loadSwiperTickets() {
  const { swiperTickets } = await import('./modules/swiper.js')
  await import('../styles/modules/swiperPhotosTickets.scss')
  swiperTickets()
}

async function loadSwiperProgram() {
  const { swiperProgram } = await import('./modules/swiper.js')
  await import('../styles/modules/swiperProgram.scss')
  swiperProgram()
}

async function loadProductSlider() {
  await import('../styles/modules/swiperProducts.scss')
  const { productSlider } = await import('./modules/productSlider')
  productSlider()
}

async function loadScroll() {
  const { scroll } = await import('./modules/functions.js')
  scroll()
}

async function makeProductsBiggerWhenLessThanFour() {
  const { makeProductsBigger } = await import('./modules/makeProductsBiggerWhenLessThanFour.js')
  makeProductsBigger();
}

async function mobileCartProductThumbs() {
  const { addMobileCartProductThumbs } = await import('./modules/mobileCartProductThumbs.js')
  addMobileCartProductThumbs();
}

async function tryToRefreshFsLightbox() {
  //@ts-expect-error unknown function
  if(typeof refreshFsLightbox === 'function') {
    //@ts-expect-error unknown function
    refreshFsLightbox();
  } else {
    await import('./libs/fslightbox.min.js');
    //@ts-expect-error unknown function
    refreshFsLightbox();
  }
}
